import cx from "classnames";
import React from "react";

import useEventCallback from "@/mk2/hooks/useEventCallback";
import { NEW_FEATURE_TAG } from "@/mk/autogenerated/translation";

import styles from "./FacetDropdownOption.mscss";

export type OptionKey = string | number;

interface OwnProps {
    className?: string;
    facetKey: string;
    optionKey: OptionKey;
    label: React.ReactNode;
    selected?: boolean;
    disabled?: boolean;
    type?: "checkbox" | "radio";
    count?: number;
    limit?: number; // Is used?
    ad?: string; // Is used?
    newFeature?: boolean; // Is used?
    optionClassName?: string;

    onChange(facetKey: string, optionKey: OptionKey, checked: boolean);
}

type Props = OwnProps;

const FacetDropdownOption = React.memo<Props>(
    ({
        className,
        facetKey,
        optionKey,
        type = "checkbox",
        label,
        disabled = false,
        selected = false,
        onChange,
        optionClassName,
        count,
        limit,
        newFeature = false,
        ad,
    }) => {
        const onChangeCallback = useEventCallback(
            (event: React.FormEvent<HTMLInputElement>) => {
                onChange(facetKey, optionKey, event.currentTarget.checked);
            },
            [onChange, facetKey, optionKey],
        );

        return (
            <label className={cx(styles.FacetDropdownOption, className, optionClassName)}>
                <div
                    className={cx(
                        styles.FacetDropdownOption__input,
                        styles[`FacetDropdownOption__input--${facetKey}-${optionKey}`],
                    )}
                >
                    {!disabled && (
                        <input
                            className={styles[`FacetDropdownOption__input__${type}`]}
                            type={type}
                            checked={selected}
                            onChange={onChangeCallback}
                        />
                    )}
                </div>
                <div className={styles.FacetDropdownOption__label}>
                    <span
                        className={cx(
                            styles.FacetDropdownOption__label__text,
                            selected && styles["FacetDropdownOption__label__text--selected"],
                        )}
                    >
                        {label}
                    </span>
                    {count !== undefined && (
                        <span className={styles.FacetDropdownOption__label__count}>{count}</span>
                    )}
                    {limit !== undefined && (
                        <span className={styles.FacetDropdownOption__label__limit}>{limit}</span>
                    )}
                    {ad !== undefined && (
                        <span className={styles.FacetDropdownOption__label__ad}>{ad}</span>
                    )}
                    {newFeature && (
                        <sup className={styles.FacetDropdownOption__label__newFeature}>
                            {NEW_FEATURE_TAG}
                        </sup>
                    )}
                </div>
            </label>
        );
    },
);

FacetDropdownOption.displayName = "FacetDropdownOption";

export default FacetDropdownOption;
